export default __webpack_public_path__ + "static/media/green-tick-ed19f842c2069a94ab6508ddb9917035.png";